import {
  handleSocketReverseMiscTransactionError,
  handleSocketReverseMiscTransactionSuccess,
} from './actions';

/**
 * Consumed by Socket context to register listeners
 */

const reverseMiscTransactionEvents = (dispatch, socket) => {
  socket.on('rmtx.error', (message) => {
    // Sanitize the error message to prevent React serialization issues
    const sanitizedMessage =
      typeof message === 'object' && message !== null
        ? {
            error:
              message.error ||
              message.text ||
              'An error occurred during misc transaction reversal',
          }
        : { error: 'An error occurred during misc transaction reversal' };
    dispatch(handleSocketReverseMiscTransactionError(sanitizedMessage));
  });

  socket.on('rmtx.success', (message) => {
    const { payload } = message;
    dispatch(handleSocketReverseMiscTransactionSuccess(payload));
  });
};

export default reverseMiscTransactionEvents;
